import { render } from "./Transcripts.vue?vue&type=template&id=c58d58ac&scoped=true&ts=true"
import script from "./Transcripts.vue?vue&type=script&lang=ts"
export * from "./Transcripts.vue?vue&type=script&lang=ts"

import "./Transcripts.vue?vue&type=style&index=0&id=c58d58ac&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c58d58ac"]])

export default __exports__